export default __webpack_public_path__ + "static/media/IconLocationFilled.d402db0c.svg";